import { Component, EventEmitter, Output } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/@auth/auth.service';
import { lastValueFrom } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { AppInfos, AuthSessionDto, CLU_MOBILE_INTERFACE } from 'src/app/app.models';
import { MfaLoginService } from './mfa-login.service';

@Component({
  selector: 'mfa-login',
  templateUrl: './mfa-login.component.html',
  styleUrls: ['./mfa-login.component.scss']
})
export class MFALoginComponent {
    @Output() onResult = new EventEmitter<string>();
    accessToken: string;
    cluInterface: CLU_MOBILE_INTERFACE;
    options = this.settings.getOptions();
    loading = false;
    errorText: string | null = null;
    codeMfaFormControl = new FormControl('', [Validators.required]);

    constructor(
        private settings: CoreService, 
        private mfaLoginService: MfaLoginService,
    ) {
    }

    async submit() {
        if (this.codeMfaFormControl.invalid) { return; }

        this.loading = true;
        try {
            const mfaToken = await this.mfaLoginService.doValidateDoubleAuthenticationCode(this.cluInterface, this.accessToken, this.codeMfaFormControl.value!);
            this.onResult.emit(mfaToken);
        } catch(err: any) {
            this.errorText = err;
            this.loading = false;
        }
    }

    exitScreen() {
        this.onResult.emit();
    }
}
